import React, { useEffect } from "react";
import Card from "@mui/material/Card";
import CardMedia from "@mui/material/CardMedia";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import ButtonGroup from "@mui/material/ButtonGroup";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Chip from "@mui/material/Chip";

import DeleteIcon from "@mui/icons-material/DeleteOutlineOutlined";
import MoreVertRoundedIcon from "@mui/icons-material/MoreVertRounded";

import { useDispatch, useSelector } from "react-redux";

import {
  addItem,
  removeItem,
  deleteItem,
  addProduct,
  setUnitSelectedIndex,
  valueItem,
} from "../slice";

import { getProductUnits } from "../slice";

import {
  cardCartMediaStyles,
  cardCartStyles,
  cardMediaStyles,
  cardSelectedStyles,
  cardStyles,
} from "./styles";
import { ComponentType} from "../../../common/enum";
import { CardActions, CardContent } from "@mui/material";

const CartItem = ({ item, t, component }) => {
  const {
    donationCart: { products, donationId },
  } = useSelector((state) => state);

  const dispatch = useDispatch();
  const units = useSelector((state) => state.donationCart.unitsByProduct[item.productId]);

  useEffect(() => {
    if (!units) {
      dispatch(getProductUnits(item.productId));
    }
  }, [dispatch, item.productId, units]);

  const [anchorEl, setAnchorEl] = React.useState(null);
  const [value, setValue] = React.useState(1);

  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const resolveValue = React.useCallback(
    (id) => {
      const productList = products.map((product) => product.productId);
      const payload = products[productList.indexOf(id)] || 0;
      return payload;
    },
    [products]
  );

  const handleValueChange = React.useCallback(
    (e) => {
      if(e.target.value != ""){
        var val = String(parseInt(e.target.value));
       // var val = String(e.target.value);
      }else{
        var val = e.target.value;
      }
      

      if (val !== "") {
        const payload = {
          donationId: donationId,
          productId: item.productId,
          totalProductQuantity: val,
          unit: units[
            resolveValue(item.productId).unitIndex !== undefined
              ? resolveValue(item.productId).unitIndex
              : 0
          ],
        };
        dispatch(addProduct(payload));
      }
      dispatch(
        valueItem({
          productId: item.productId,
          value: val,
        })
      );
    },
    [item, dispatch]
  );

  const handleMenuItemClick = (event, unit, index) => {
    const payload = {
      donationId: donationId,
      productId: item.productId,
      totalProductQuantity: resolveValue(item.productId).count,
      unit: unit.unitName,
      IDUnit: unit.id,
    };

    dispatch(addProduct(payload));
    dispatch(setUnitSelectedIndex({ productId: item.productId, index }));

    setAnchorEl(null);
  };

const onAdd = async (e, item) => {
  e.preventDefault();

  let productUnits = [];


    const resultAction = await dispatch(getProductUnits(item.productId));

    if (getProductUnits.fulfilled.match(resultAction)) {
      productUnits = resultAction.payload.data;
    } else {
      console.error("Erro ao carregar unidades do produto");
      return;
    }
 

  if (!productUnits || productUnits.obj.length === 0) return;
    // const selectedUnit = productUnits.obj[0];

    const payload = {
      donationId: donationId,
      productId: item.productId,
      totalProductQuantity:
        resolveValue(item.productId).count > 0
          ? resolveValue(item.productId).count + 1
          : 1,
      unit: units.obj[resolveValue(item.productId).unitIndex ?? 0].unitName,
      IDUnit: units.obj[resolveValue(item.productId).unitIndex ?? 0].id,
    };

    dispatch(addProduct(payload));
    dispatch(addItem(item));
  };

  const onRemove = (e, item) => {
    e.preventDefault();
    const payload = {
      donationId: donationId,
      productId: item.productId,
      totalProductQuantity:
        resolveValue(item.productId).count > 0
          ? resolveValue(item.productId).count - 1
          : 0,
      unit:  units.obj[resolveValue(item.productId).unitIndex ?? 0].unitName,
    };
    dispatch(addProduct(payload));
    const productId = item.productId;
    dispatch(removeItem({ productId }));
    if(payload.totalProductQuantity == 0){
      dispatch(deleteItem({ productId }));
    }
    
  };

  const onDeleteItem = (e, item) => {
    e.preventDefault();
    const payload = {
      donationId: donationId,
      productId: item.productId,
      totalProductQuantity: 0,
      unit: units[resolveValue(item.productId).unitIndex],
    };
    dispatch(addProduct(payload));
    const productId = item.productId;
    dispatch(deleteItem({ productId }));
  };

  const cardStyle = React.useMemo(() => {
    const matchProduct = products.some((p) => p.productId === item.productId);
    if (matchProduct) {
      return cardSelectedStyles;
    } else {
      return cardStyles;
    }
  }, [products, item]);

  return (
    <>
      <Card
        className="CartProd"
        sx={component === ComponentType.PRODUCT ? cardStyle : cardCartStyles}
        variant="outlined"
      >
        <CardMedia
          component="img"
          sx={
            component === ComponentType.PRODUCT
              ? cardMediaStyles
              : cardCartMediaStyles
          }
          image={
            item?.productId
              ? `/static/products/${item?.productId}.jpg`
              : "/static/dashboard/oranges.svg"
          }
          alt={item?.productId ? `${item.productGroup}` : "product image"}
        />
        <Box
          sx={{
            flex: "1 1 auto",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
          }}
        >
          <CardContent sx={{ padding: "8px" }}>
            <Typography
              component="h6"
              variant="h6"
              fontSize={"14px  !important"}
            >
              {item.productName === "" ? item.productType : item.productName}
            </Typography>
            {component === ComponentType.PRODUCT && (
              <>
                <Chip
                  sx={{
                    backgroundColor: "#E4F2E8",
                    color: "#1B727E",
                    my: "5px",
                    mr: "5px",
                    "& .MuiChip-label": { fontWeight: "bold" },
                  }}
                  label={item.productGroup}
                  size={"medium"}
                />
                {item.productName != "" &&
                <Chip
                  sx={{
                    backgroundColor: "#E4F2E8",
                    color: "#1B727E",
                    my: "5px",
                    mr: "5px",
                    "& .MuiChip-label": { fontWeight: "bold" },
                  }}
                  label={item.productType}
                  size={"medium"}
                />}
              </>
            )}
          </CardContent>
          <CardActions sx={{ p: 0 }}>
            <ButtonGroup
              size="large"
              fullWidth={component === ComponentType.PRODUCT ? true : false}
              sx={{
                mx: component === ComponentType.PRODUCT ? 0 : 1,
                "& .MuiButtonGroup-grouped": {
                  minWidth: 30,
                  
                },
              }}
            >
              {resolveValue(item.productId).count > 0 ||
              resolveValue(item.productId).count === "" ? (
                <>
                  <Button
                    onClick={(e) => {
                      onRemove(e, item);
                    }}
                    sx={{
                      p: 0,
                      borderTopRightRadius: 0,
                      borderBottomRightRadius: 0,
                      borderTopLeftRadius: "4px",
                      borderBottomLeftRadius: "4px",
                      width: "auto"
                    }}
                    size="large"
                  >
                    -
                  </Button>
                  <input
                    type="text"
                    style={{
                      width: "40px",
                      textAlign: "center",
                      fontSize:
                        (item.count || 1).toString().length >= 4
                          ? "12px"
                          : "16px",
                      border: "0.5px solid #37B34A",
                    }}
                    value={resolveValue(item.productId).count}
                    onChange={handleValueChange}
                    min={1}
                    // readOnly
                  />
                  <Button
                    onClick={(e) => {
                      onAdd(e, item);
                    }}
                    size="large"
                    sx={{
                      p: 0,
                      borderRadius: 0,
                      width: "auto"
                    }}
                  >
                    +
                  </Button>
                  <Button
                    size="large"
                    endIcon={<MoreVertRoundedIcon />}
                    variant="contained"
                    onClick={handleClick}
                    sx={{
                      ml: 0,
                      p: component === ComponentType.PRODUCT ? "8px 22px" : 0.5,
                      minWidth: 0,
                      fontSize: "12px",
                      borderRadius: "0 4px 4px 0",
                    }}
                  >
                  {units && units.obj.length > 0
                    ? units.obj[
                        resolveValue(item.productId).unitIndex ?? 0
                      ].unitName
                    : "Valor"}
                    {/* {t(`${units[resolveValue(item.productId).unitIndex]}`)} */}
                  </Button>
                </>
              ) : (
                <>
                  <Button
                    fullWidth
                    size="large"
                    variant="contained"
                    sx={{
                      backgroundColor: "#E1EFB0",
                      color: "#37773E",
                      "&:hover": { color: "#E1EFB0" },
                      borderRadius: "4px",
                    }}
                    onClick={(e) => {
                      onAdd(e, item);
                    }}
                  >
                    {t("addProduct")}
                  </Button>
                </>
              )}
            </ButtonGroup>
            {component === ComponentType.CART_PRODUCT && (
              <Button
                variant="secondary"
                onClick={(e) => onDeleteItem(e, item)}
                sx={{
                  minWidth: 0,
                  p: 0.5,
                  backgroundColor: "rgba(33, 43, 54, 0.08)",
                }}
              >
                <DeleteIcon />
              </Button>
            )}
          </CardActions>
        </Box>
      </Card>
      <Menu
        id="long-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        {units !== undefined && Array.isArray(units.obj) && units.obj.length > 0 ?  (
          units.obj.map((unit, index) => (
            <MenuItem
              key={index}
              selected={index === resolveValue(item.productId).unitIndex}
              onClick={(event) => handleMenuItemClick(event, unit, index)}
            >
              {t(unit.unitName)}
            </MenuItem>
          ))
        ) : (
          <MenuItem disabled>{t("No units available")}</MenuItem>
        )}
      </Menu>
    </>
  );
};

export default CartItem;
